<template>
  <v-container
    fluid
    class="pa-0 ma-0"
  >
    <v-card-title
      class="d-flex flex-row justify-space-between"
    >
      <v-btn-toggle
        v-model="mode"
        mandatory
        rounded
        background-color="transparent"
      >
        <v-btn value="register">
          Sign Up
        </v-btn>
        <v-btn value="login">
          Sign In
        </v-btn>
      </v-btn-toggle>

      <required v-if="showRequired" />
      <guest-continue
        v-if="showGuestContinue"
        v-on="$listeners"
      />

      <div
        v-if="auth.set"
      >
        Hi {{ auth.name }}
        <v-btn
          icon
          @click="logout"
        >
          <v-icon>
            mdi-logout
          </v-icon>
        </v-btn>
      </div>

      <close-button />
    </v-card-title>

    <v-card-text>
      <v-tabs-items
        v-if="!auth.set"
        v-model="mode"
        light
      >
        <v-tab-item value="login">
          <login
            :busy="updateBusy"
            v-on="$listeners"
          />
        </v-tab-item>
        <v-tab-item value="register">
          <register
            @reset="mode='login'"
            v-on="$listeners"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </v-container>
</template>

<script>
import Register from './Register.vue'
import Login from './Login.vue'
import Required from './Required'
import GuestContinue from './GuestContinue'
import CloseButton from '../CloseButton'

export default {
  components: { Login, Register, Required, GuestContinue, CloseButton },
  props: ['showRequired', 'showGuestContinue'],
  data() {
    return {
      mode: 'register',
      busy: false
    }
  },
  watch:{
    auth(){
      this.show = this.auth.login // opens the login dialog
      this.busy = false
    }
  }, 
  methods:{
    updateBusy(v){this.busy = v},
    logout(){
      this.api.logout()
    }
  },
}
</script>